/* eslint-disable */
<template>
  <interact resizable :resizeOption="resizeOption" :data-app-theme="$store.getters.theme"
    draggable
    :dragOption="dragOption"
    class="resize-drag"
    :style="style"
    @dragmove="dragmove"
    @resizemove="resizemove"
    :class="{ fullscreen: $store.getters.isFullscreenPhotoEditor }"
  >
    <div
      class="about-me"
      id="container"
      :class="{
        fullscreen: $store.getters.isFullscreenPhotoEditor,
        close: !$store.getters.isShownPhotoEditor,
      }"
    >
      <div
        class="top-bar app-toolbar"
        id="top-bar"
        v-on:dblclick="$store.commit('toggleFullscreenPhotoEditor')"
      >
        <div class="triple-button">
          <div class="button-red" v-on:click="closePhotoEditor"></div>
          <div class="button-yellow"></div>
          <div
            class="button-green"
            v-on:click="$store.commit('toggleFullscreenPhotoEditor')"
          ></div>
        </div>
      </div>
      <div class="bar"></div>
      <div class="content">
        <iframe
          src="https://www.photopea.com#%7B%7D"
          style="width: 100%; height: 100%; border: none"
        ></iframe>
        <div
          class="scroll-container"
          :class="{
            expandedScrollContainer: $store.getters.isFullscreenPhotoEditor,
          }"
        >
          <br />
        </div>
      </div>
      <div class="resizer resizer-b"></div>
      <div class="resizer resizer-l"></div>
      <div class="resizer resizer-t"></div>
      <div class="resizer resizer-r"></div>
    </div>
  </interact>
</template>

<style scoped>
/* iframe {
  pointer-events: none;
} */
.resize-drag {
  box-sizing: border-box;
  background: none;
  user-select: auto;
  -ms-touch-action: auto;
  touch-action: auto;
  min-height: 40px;
  min-width: 350px;
  position: sticky;
  cursor: auto !important;
  width: min(1000px, 92vw);
  height: min(700px, 82vh);
}

.about-me {
  min-height: 600px;
  min-width: 350px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  background: #f3f2f2;
  overflow: hidden;
  border: 1px solid #dadada;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.14);
  /* transition: all 0.5s ease; */
  max-height: 100%;
  max-width: 100%;
  align-items: flex-end;
}

@media only screen and (max-width: 600px) {
  .resize-drag { width: 90vw; height: 76vh; min-width: 0; }
  .about-me {
    min-width: 50vw;
    width: 90vw;
    max-width: 100vw;
  }
  .scroll-container {
    padding-left: 10vw !important;
    padding-right: 10vw !important;
  }
  .expandedScrollContainer {
    padding-left: 10vw !important;
    padding-right: 10vw !important;
  }
}

.images {
  width: 100%;
  border-radius: 15px;
  height: 350px;
  object-fit: cover;
}

.images-full {
  width: 100%;
  border-radius: 15px;
  height: auto;
  object-fit: cover;
}

.subtitle {
  font-size: 12px;
  color: gray;
  text-align: center;
}

.heading {
  padding-bottom: 5px;
}

.inner-content {
  padding-top: 30px;
}

.inner-content:last-child {
  padding-bottom: 30px;
}

.fullscreen {
  width: 100% !important;
  height: 100vh !important;
  margin: 0;
  transition: all 0.5s ease;
  padding: 0;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  position: fixed !important;
  z-index: 9999;
}

.fullscreen iframe {
  width: 100%;
  height: 100vh;
  border: none;
  display: block;
}

.close {
  display: none;
}

.show {
  display: block;
}

.textarea-content {
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;
  caret-color: black;
  color: black;
}

.bar {
  background: #dadada;
  height: 1px;
  width: 100%;
}

.circle {
  background: #f1f0f2;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}

.header {
  font-weight: 700;
  font-size: 28px;
  padding-top: 10px;
}

.scroll-container {
  overflow: scroll;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 20px;
}

.expandedScrollContainer {
  padding-left: 25vw;
  padding-right: 25vw;
}

.paragraph {
  font-weight: 100;
  font-size: 14px;
  padding-bottom: 10px;
}

/* .resizer-r {
  cursor: col-resize;
  height: 100%;
  right: 0;
  top: 0;
  width: 5px;
}

.resizer-b {
  bottom: 0;
  cursor: row-resize;
  height: 5px;
  left: 0;
  width: 100%;
}

.resizer-t {
  top: 0;
  cursor: row-resize;
  height: 5px;
  left: 0;
  width: 100%;
}

.resizer-l {
  cursor: col-resize;
  height: 100%;
  left: 0;
  bottom: 0;
  width: 5px;
}

.resizer {
  position: absolute;
} */

[data-app-theme="dark"] .about-me, .about-me[data-app-theme="dark"] {
    border: 1px solid rgb(255, 255, 255, 0.2);
    background: #1c1c1d;
  }

[data-app-theme="dark"] .top-bar, .top-bar[data-app-theme="dark"] {
    background: #333333;
  }

[data-app-theme="dark"] .bar, .bar[data-app-theme="dark"] {
    background: #0b0a0b;
  }

[data-app-theme="dark"] .hello, .hello[data-app-theme="dark"] {
    color: white;
  }

[data-app-theme="dark"] .textarea-content, .textarea-content[data-app-theme="dark"] {
    caret-color: white;
    color: white;
  }

[data-app-theme="dark"] .header, .header[data-app-theme="dark"] {
    color: white;
  }

[data-app-theme="dark"] .paragraph, .paragraph[data-app-theme="dark"] {
    color: white;
  }

[data-app-theme="dark"] .heading, .heading[data-app-theme="dark"] {
    color: white;
  }
</style>

<script>
import interact from "interactjs";
export default {
  props: {
    // shownProp: Boolean
  },
  data: function () {
    return {
      resizeOption: {
        edges: { top: true, left: true, bottom: true, right: true },
      },
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
      dragOption: {
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true,
          }),
        ],
        allowFrom: ".top-bar",
      },

      // values for interact.js transformation
      x: 0,
      y: 0,
    };
  },
  computed: {
    style() {
      return {
        height: `${this.h}px`,
        width: `${this.w}px`,
        transform: `translate(${this.x}px, ${this.y}px)`,
        "--fullscreen": window.innerHeight - 30 + "px",
      };
    },
  },
  methods: {
    dragmove(event) {
      this.x += event.dx;
      this.y += event.dy;
      this.$store.commit("zIndexIncrement", "photoeditor");
    },
    resizemove(event) {
      this.w = event.rect.width;
      this.h = event.rect.height;

      this.x += event.deltaRect.left;
      this.y += event.deltaRect.top;
    },
    dragMouseDown: function (event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function (event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        "px";
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        "px";
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    closePhotoEditor(e) {
      e.stopPropagation();
      this.$store.commit("toggleShownPhotoEditor", false);
      this.$store.commit("changeActiveWindow", "Finder");
    },
  },
  mounted: function () {
    // Query the element
    const ele = document.getElementById("container");

    // The current position of mouse
    let x = 0;
    let y = 0;

    // The dimension of the element
    let w = 0;
    let h = 0;

    const mouseDownHandlerRight = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerRight);
      document.addEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseDownHandlerLeft = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerLeft);
      document.addEventListener("mouseup", mouseUpHandlerLeft);
    };

    const mouseDownHandlerUp = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerUp);
      document.addEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseDownHandlerDown = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerDown);
      document.addEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseMoveHandlerUp = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h - dy}px`;
    };

    const mouseMoveHandlerDown = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h + dy}px`;
    };

    const mouseMoveHandlerRight = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w + dx}px`;
    };

    const mouseMoveHandlerLeft = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w - dx}px`;
    };

    const mouseUpHandlerUp = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerUp);
      document.removeEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseUpHandlerDown = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerDown);
      document.removeEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseUpHandlerRight = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerRight);
      document.removeEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseUpHandlerLeft = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerLeft);
      document.removeEventListener("mouseup", mouseUpHandlerLeft);
    };
    // Query all resizers
    const resizersRight = ele.querySelectorAll(".resizer-r");
    const resizersUp = ele.querySelectorAll(".resizer-t");
    const resizersDown = ele.querySelectorAll(".resizer-b");
    const resizersLeft = ele.querySelectorAll(".resizer-l");

    [].forEach.call(resizersRight, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerRight);
    });

    [].forEach.call(resizersUp, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerUp);
    });

    [].forEach.call(resizersDown, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerDown);
    });

    [].forEach.call(resizersLeft, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerLeft);
    });
  },
};
</script>
